import { useEffect, useRef } from 'react';
import Assets from 'imports/assets.import';
import MenuItem from 'common_components/ui/menu_item/menu_item.ui';
import { STRINGS } from 'constants/strings.constant';
import { ActionPopupProps } from 'interfaces/project.interface';
import './action_popup.component.scss';

const ActionPopupForProjects = (props: ActionPopupProps) => {
  const { handleManageExpiry, handleDelete, onClose } = props;
  const popupRef = useRef<HTMLDivElement>(null);
  const copy = STRINGS.project.rowActions;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="action_popup" ref={popupRef} onClick={(e) => e.stopPropagation()}>
      <div role="menu" className="action_popup_items">
        {handleManageExpiry && (
          <>
            <MenuItem icon={Assets.calendar_outline} label={copy.manageExpiry} onClick={handleManageExpiry} />
            <div role="separator" className="action_popup_divider" />
          </>
        )}
        <MenuItem icon={Assets.trash_danger} label={copy.delete} onClick={handleDelete} isDanger />
      </div>
    </div>
  );
};

export default ActionPopupForProjects;
